import evergemRender from "@/assets/images/3D_render_doornzele.webp";
import dokterspraktijkKasteeldreef from "@/assets/realisaties/dokterspraktijk_kasteeldreef.webp";
import denOudenPost from "@/assets/realisaties/den_ouden_post.webp";
import residentieExaerde1 from "@/assets/realisaties/residentie_exaerde_1.webp";
import residentieExaerde2 from "@/assets/realisaties/residentie_exaerde_2.webp";
import rozenstraatLokeren1 from "@/assets/realisaties/rozenstraat_lokeren_1.webp";
import rozenstraatLokeren2 from "@/assets/realisaties/rozenstraat_lokeren_2.webp";
import rozenstraatLokeren3 from "@/assets/realisaties/rozenstraat_lokeren_3.webp";

const projectImages = {
  kasteeldreef: [
    {
      src: dokterspraktijkKasteeldreef,
      alt: "Render van Dokterspraktijk Kasteeldreef",
      objectPosition: "center center",
    },
  ],
  exaerde: [
    {
      src: residentieExaerde1,
      alt: "Render van Residentie Exaerde, vooraanzicht",
      objectPosition: "center center",
    },
    {
      src: residentieExaerde2,
      alt: "Render van Residentie Exaerde, achteraanzicht",
      objectPosition: "center center",
    },
  ],
  denOudenPost: [
    {
      src: denOudenPost,
      alt: "Render van Residentie Den Ouden Post",
      objectPosition: "center center",
    },
  ],
  rozenstraat: [
    {
      src: rozenstraatLokeren1,
      alt: "Render van Rozenstraat Lokeren, beeld 1",
      objectPosition: "center center",
    },
    {
      src: rozenstraatLokeren2,
      alt: "Render van Rozenstraat Lokeren, beeld 2",
      objectPosition: "center center",
    },
    {
      src: rozenstraatLokeren3,
      alt: "Render van Rozenstraat Lokeren, beeld 3",
      objectPosition: "center center",
    },
  ],
};

// Realisaties — eenvoudig uit te breiden: voeg een object toe aan deze lijst.
export const projects = [
  {
    slug: "villa-eksaarde",
    name: "Dokterspraktijk Kasteeldreef",
    location: "Eksaarde",
    type: "Nieuwbouw praktijk",
    year: "2014",
    images: projectImages.kasteeldreef,
    cover: projectImages.kasteeldreef[0].src,
    intro: "Een eigentijdse dokterspraktijk waar heldere architectuur en een gastvrije uitstraling samenkomen.",
    description:
      "Dokterspraktijk Kasteeldreef wordt opgevat als een functionele en verfijnde zorgomgeving, met aandacht voor comfort, licht en een doordachte circulatie.",
    facts: [
      { label: "Type", value: "Vrijstaande nieuwbouw" },
      { label: "Oppervlakte", value: "290 m²" },
      { label: "Oplevering", value: "2014" },
      { label: "Energie", value: "E-peil 28" },
    ],
    gallery: projectImages.kasteeldreef,
    featured: true,
  },
  {
    slug: "woning-lokeren",
    name: "Residentie Den Ouden Post",
    location: "Eksaarde",
    type: "Nieuwbouw appartementen",
    year: "2013",
    images: projectImages.exaerde,
    cover: projectImages.exaerde[0].src,
    intro: "Een stijlvol appartementsproject dat hedendaags wooncomfort verenigt met een tijdloze architectuur.",
    description:
      "Residentie Den Ouden Post biedt kwalitatieve appartementen met een evenwichtige indeling, een verfijnde materialisatie en bijzondere aandacht voor licht en leefkwaliteit.",
    facts: [
      { label: "Type", value: "5 Appartementen" },
      { label: "Oppervlakte", value: "75-140 m² per unit" },
      { label: "Oplevering", value: "2013" },
      { label: "Energie", value: "E-peil 28" },
    ],
    gallery: projectImages.exaerde,
    featured: false,
  },
  {
    slug: "residentie-daknam",
    name: "Residentie Exaerde",
    location: "Eksaarde",
    type: "Nieuwbouw appartementen",
    year: "2011",
    images: projectImages.denOudenPost,
    cover: projectImages.denOudenPost[0].src,
    intro: "Een karaktervol appartementsproject waarin hedendaags wooncomfort en een verfijnde uitstraling centraal staan.",
    description:
      "Residentie Exaerde combineert een doordachte architectuur met kwalitatieve woonruimtes en een duurzame, tijdloze materialisatie.",
    facts: [
      { label: "Type", value: "6 Appartementen" },
      { label: "Oppervlakte", value: "95-125 m² per unit" },
      { label: "Oplevering", value: "2011" },
      { label: "Energie", value: "E-peil 30" },
    ],
    gallery: projectImages.denOudenPost,
    featured: false,
  },
  {
    slug: "woning-zele",
    name: "Rozenstraat Lokeren",
    location: "Lokeren",
    type: "Nieuwbouw woning",
    year: "2025",
    images: projectImages.rozenstraat,
    cover: projectImages.rozenstraat[0].src,
    intro: "Een hedendaagse nieuwbouwwoning met een rustige architectuur en een hoogwaardige, tijdloze uitstraling.",
    description:
      "De woning aan de Rozenstraat wordt gekenmerkt door heldere volumes, een evenwichtige indeling en bijzondere aandacht voor comfort, licht en materiaalkeuze.",
    facts: [
      { label: "Type", value: "Twee halfopen woningen" },
      { label: "Oppervlakte", value: "210 m² per woning" },
      { label: "Oplevering", value: "2025" },
      { label: "Energie", value: "E-peil 20" },
    ],
    gallery: projectImages.rozenstraat,
    featured: false,
  },
].sort((a, b) => Number(b.year) - Number(a.year));

// TODO: Vervang cover en intro zodra de definitieve Evergem-content beschikbaar is.
export const featuredProject = {
  name: "Project Doornzele",
  location: "Evergem · Halfopen nieuwbouwwoning",
  cover: evergemRender,
  intro: "De laatste beschikbare halfopen nieuwbouwwoning in Project Doornzele, met een tijdloze architectuur, hoogwaardige afwerking en veel natuurlijk licht.",
  url: "https://lxbouw.be/projecten/evergem/",
};

export const getProject = (slug) => projects.find((p) => p.slug === slug);
